import { CheckOutlined, CloseOutlined } from '@ant-design/icons';
import { Tag } from 'antd';
import { useTheme } from 'styled-components';

export interface TagCheckedProps {
  checked?: boolean | null;
}

/**
 * Tag colorata con check o cross
 */
export function TagChecked(props: TagCheckedProps) {
  const theme = useTheme();
  const { checked } = props;
  return (
    <Tag color={checked ? theme.colorSuccess : theme.colorError}>
      {checked ? (
        <CheckOutlined aria-label="Si" />
      ) : (
        <CloseOutlined aria-label="No" />
      )}
    </Tag>
  );
}
